import { Module } from 'vuex'
import {
// actConf,
// queryOperationPopup,
  queryVideoAd
} from '@/services/index'

interface ActState {
  adInfo: any// actConfig: any
}

const act: Module<ActState, any> = {
  namespaced: true,
  state: {
    // actConfig: '', // 活动配置信息
    adInfo: {}
  },
  getters: {
    adInfo(state) {
      const { quota = 0, done = 0, quotaTime } = state.adInfo
      const residue = quota - done
      const time = new Date(quotaTime || new Date())

      return {
        residue,
        done: 0,
        complete: quota === done,
        year: time.getFullYear(),
        month: time.getMonth() + 1,
        date: time.getDate(),
        ...state.adInfo
      }
    }
    // 活动配置
    // actConfig(state) {
    //   let config = {
    //     actStatus: 2,
    //     actStartTime: '',
    //     actEndTime: '',
    //     currentTime: +new Date(),
    //     extMap: {
    //     }
    //   }
    //   if (typeof state.actConfig === 'object') {
    //     config = state.actConfig
    //   }
    //   return {
    //     ...config,
    //   }
    // },
    // 活动是否进行中
    // actRunning(state, getters) {
    //   return getters.actConfig.actStatus === 2
    // },
  },
  mutations: {
    // updateActConfig(state, config) {
    //   state.actConfig = config
    // },
    updateAdInfo(state, data) {
      state.adInfo = data
    }
  },
  actions: {
    // 初始化信息
    async bootstrap({ dispatch, rootState } :any, { force = false } = {}) {
      force && console.log('Refresh bootstrap')
      await dispatch('slientLogin', true, { root: true }).catch(() => {})
      await dispatch('getAdInfo', { force })
      // if (rootState.common.loginState) {
      // }

      return Promise.resolve(rootState.common.loginState)
    },
    async getAdInfo({ commit, rootGetters }) {
      const { UUID, platform } = rootGetters.phoneInfo
      const res = await queryVideoAd(UUID, platform)
      if (res.data) {
        commit('updateAdInfo', res.data)
      } else {
        commit('updateAdInfo', { NoQuota: true })
      }
    }
  }
}

export default act
